







































































































































































declare var window: any;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobsStore } from './../models/jobs/jobs.vuex';
import { Job } from './../models/jobs/job';
import { Facility } from './../models/jobs/facility';
import { vxm } from './../store.vuex';
import { ATSJobListParams } from '../models/jobs/atsjoblistparams';
import Referrals from './Referrals.vue';
import JobPager from './JobPager.vue';
import { ApplyRequestWrapper } from '../models/jobs/jobapply';
import { Referral } from '../models/referrals/referral';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../router';
import MessageModal from './Commons/MessageModal.vue';
import JobMainInfo from '@/components/Commons/JobMainInfo.vue';
import { JobTagConfig } from './../models/jobs/jobtagconfig';
import QuickSignupForm from '@/components/QuickApply/QuickSignupForm.vue';
import QuickJobApplyPopup from '@/components/QuickApply/QuickJobApplyPopup.vue';

import {
  JOB_PAY_UOM_HOUR,
  JOB_PAY_UOM_TIMESLOT,
  JOB_PAY_UOM_YEAR,
  JOB_PAY_UOM_WEEK,
} from './MyJobs/MyJobsConstants';
import ReferralProgramusd from './SvgIcons/ReferralProgramusd.vue';
import ReferralProgramgbp from './SvgIcons/ReferralProgramgbp.vue';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'Joblisting',
  components: {
    Referrals,
    JobPager,
    ReferralProgramusd,
    ReferralProgramgbp,
    JobMainInfo,
    QuickSignupForm
  },
})
export default class Joblisting extends Vue {
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private jobListing: Job[] = [];
  private expandedJobs: number[] = [];
  $wlToastr: any;
  $moment: any;
  private locationType: string = '';
  private locShortName: string = '';
  private bookmarks: any[] = [];
  public message = 'Your application is being reviewed';
  private externalUrl = '';
  public externalJobId = '';
  public localjobs: Job[] = [];

  get canShowChat() {
    return false;
  }

  get referralEnabled() {
    return vxm.configs.isReferralEnabled('REFERRAL_ENABLED');
  }

  get canShowJobDetails() {
    return !vxm.configs.getGlobalConfigValue(
      'HIDE_JOB_DETAILS_IN_JOB_LIST_PAGE',
    );
  }

  get cssWithoutReferral() {
    return this.referralEnabled ? 'apply-refer' : 'apply-without-refer';
  }

  get canShowBookMark() {
    return (job) => {
      if (this.isLoggedIn) {
        return !job.hasAppliedJob;
      }
      return vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS');
    };
  }

  formattingJobDescription(jobDescription: any) {
    if (jobDescription && jobDescription.startsWith('<p>')) {
      return jobDescription.slice(3);
    }
    return jobDescription;
  }

  get isJobLevelChat() {
    return false
  }

  getDistance(job: Job) {
    if (job.distance) {
      if (job.distance > 0.1) {
        return job.distance.toFixed(1);
      } else {
        return '< 0.1';
      }
    } else {
      return '0.0';
    }
  }

  bookmarkJob(job: any) {

    if (
      vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS') &&
      !this.isLoggedIn
    ) {
      const found = this.localjobs.find(
        (element) => element.jobPostingId == job.jobPostingId,
      );
      if (found) {
        const vm = this;
        console.log('got job:' + job.jobPostingId);
        this.localjobs.forEach((item, index) => {
          if (item.jobPostingId == job.jobPostingId) {
            this.localjobs.splice(index, 1);
            console.log('deleting job');
          }
        });
        localStorage.setItem('localjobs', JSON.stringify(this.localjobs));
        vxm.utility.setLocaljobs(this.localjobs);
        vm.$wlToastr('success', vm.$t('MyJobListing_JobUnsavevSuccess'), vm.$t('savedJobs.text'));
      } else {
        const vm = this;
        this.localjobs.push(job);
        localStorage.setItem('localjobs', JSON.stringify(this.localjobs));
        vxm.utility.setLocaljobs(this.localjobs);
        vm.$wlToastr('success', vm.$t('MyJobListing_JobSavedSuccess'), vm.$t('savedJobs.text'));
      }
      return;
    }
    let jobs = this.bookmarks.filter(
      (bookmark) => bookmark.objectId === job.jobPostingId,
    );
    if (jobs && jobs.length > 0) {
      for (let bookmark of this.bookmarks) {
        if (job.jobPostingId == bookmark.objectId) {
          if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
            job.bookmarkStatus = 'D';
            bookmark.action = 'D';
          } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
            job.bookmarkStatus = 'A';
            bookmark.action = 'A';
          }
        }
      }
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      job.bookmarkStatus = 'D';
      this.bookmarks.push({
        action: 'D',
        type: '01',
        objectId: job.jobPostingId,
      });
      vxm.users.Rudderstack.trackEvent('Job Unsaved', {
        jobPostingId: job.jobPostingId,
        jobPostingTitle: job.jobPostingName,
      });
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      vxm.users.Rudderstack.trackEvent('Job Saved', {
        jobPostingId: job.jobPostingId,
        userAppliedtoJob: job.hasAppliedJob,
        jobPostingTitle: job.jobPostingName,
      });
      job.bookmarkStatus = 'A';
      this.bookmarks.push({
        action: 'A',
        type: '01',
        objectId: job.jobPostingId,
      });
    }

    let bookmarkIcon = this.$refs['bookmark_' + job.jobPostingId];
    if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      bookmarkIcon[0].classList = ['fa fa-bookmark secondary-color bookmark-icon'];
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      bookmarkIcon[0].classList = [
        'fa fa-bookmark-o remove-color bookmark-icon',
      ];
    }
    let req = {
      sessionToken: '13223',
      bookmarks: this.bookmarks,
    };
    if (this.bookmarks && this.bookmarks.length > 0) {
      vxm.jobs.bookmarkJob(req).then((resp) => { });
    }
  }

  getJobTags(jobTags: string) {
    if (jobTags) {
      let jobTagValues = new Set(jobTags);
      let jobTagConfigs: JobTagConfig[] = vxm.jobs.JobTagConfigs;
      if (jobTagConfigs && jobTagConfigs.length > 0) {
        return jobTagConfigs
          .filter((tagConf) => jobTagValues.has(tagConf.tagName))
          .sort((a, b) => a.sequence - b.sequence);
      }
      return [];
    }
    return [];
  }

  goTodetail2(jid: string) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    this.$router.push({
      path: `/jobdetails/${jid}?apply=true`,
    });
  }

  goTodetail(jid: string) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    localStorage.jobviewpage = true;
    this.$router.push({
      name: 'Jobdetails',
      params: { JobID: jid },
    });
  }
  goTodetailWithTitle(jid: string, jTitle: string, facility: Facility) {
    if (this.$cookies.get('SubmitJobApplicationId')) {
      this.$cookies.remove('SubmitJobApplicationId');
    }
    vxm.jobs.setJobID(parseInt(jid, 10));
    let city = facility.city ? facility.city.trim() : facility.city;
    localStorage.jobviewpage = true;
    let jobTitleSlug = this.jobTitleCitySlug(jTitle, city);
    // window.rudderanalytics.group("OUTSRCQA", {
    //   companyCode : "OUTSRCQA"
    // }, () => {
    //   console.log("group executed on job click");
    // })
    //window.rudderanalytics.page("Job Click", "Find jobs", () => { console.log("clicked on a job in find jobs")})
    vxm.users.Rudderstack.trackEvent('Job Details Viewed', {
      jobPostingId: jid,
      jobPostingTitle: jTitle,
    });
    this.$router.push({
      name: 'JobdetailsSlug',
      params: { JobID: jid, JobSlug: jobTitleSlug },
    });
  }

  jobTitleCitySlug(jTitle: string, city: string): string {
    let slug = '';
    slug = jTitle;
    slug = slug.replace(/\/|\s/g, '-');
    if (city && city.length > 0) {
      slug = slug.concat('-in-').concat(city);
    }
    slug = slug
      .replace(/---|-\/-/g, '-')
      .replace(/[.,\/#!$%\^&\*;:{}=\-–_`~()]/g, ' ')
      .replace(/\s\s+/g, ' ')
      .replace(/ /g, '-')
      .toLowerCase();
    return slug;
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
  }

  goToUpload(job: any) {
    vxm.users.Rudderstack.trackEvent('Job Apply Selected', {
      userAppliedtoJob: job.hasAppliedJob,
      jobPostingId: job.jobPostingId,
    });
    const jid = job.jobPostingId;
    const externalJobUrl = job.externalJobUrl;

    const vm = this;
    if (!vxm.users.getToken) {
      if (externalJobUrl === null) this.setNavigation('JobDetails:' + jid);
      //this.$router.push({ name: 'Login' });
      if (externalJobUrl != null) {
        this.showPopup(
          'Login',
          this.$t('Jobdetails_LoginPrompt').toString(),
          jid,
        );
      } else if (vxm.configs.getGlobalConfigValue('QUICK_JOB_APPLY_ENABLED')) {
        vxm.jobs.setJobID(parseInt(jid, 10));
        this.$router.push({ path: `/quickapply/${jid}?apply=true` });
      } else {
        this.$cookies.set('SubmitJobApplicationId', jid, 600);
        this.$router.push({ name: 'Login' });
      }
    } else {
      if (externalJobUrl != null) {
        this.showPopup(
          externalJobUrl,
          this.$t('Jobdetails_RedirectionPrompt').toString(),
          jid,
        );
      } else {
        this.applyJob(jid);
      }
    }
  }

  quickApplyJob(jid: string) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    const jobApply = new ApplyRequestWrapper();
    jobApply.accessToken = vxm.users.getToken;
    jobApply.applyRequest.jobPostingId = parseInt(jid, 10);

    jobApply.applyRequest.companyCode = vxm.jobs.BrandingInfo.companycode;
    const respPromise: any = vxm.jobs.getNexSteps(jobApply);
    this.$modal.show('survey-spinner');
    Promise.all([respPromise]).then((values) => {
      this.$modal.hide('survey-spinner');
      const resp = values[0] && values[0].data ? values[0].data : values[0];
      if (resp) {
        this.processJobApplicationResponse(resp, jid);
      }
    });
  }

  applyJob(jid: string) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    const jobApply = new ApplyRequestWrapper();
    jobApply.accessToken = vxm.users.getToken;
    jobApply.applyRequest.jobPostingId = parseInt(jid, 10);

    jobApply.applyRequest.companyCode = vxm.jobs.BrandingInfo.companycode;
    const respPromise: any = vxm.jobs.getNexSteps(jobApply);
    this.$modal.show('survey-spinner');
    Promise.all([respPromise]).then((values) => {
      this.$modal.hide('survey-spinner');
      const resp = values[0] && values[0].data ? values[0].data : values[0];
      if (resp) {
        this.processJobApplicationResponse(resp, jid);
      }
    });
  }

  showPopup(externalJobUrl: string, message: string, jid: string) {
    this.externalUrl = externalJobUrl;
    this.externalJobId = jid;
    this.$modal.show(
      MessageModal,
      {
        body: message,
        onOk: () => this.onPopUpOk(externalJobUrl, jid)(),
        onCancel: () => this.onPopUpCancel(jid),
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
  onPopUpCancel(jid) {
    vxm.users.Rudderstack.trackEvent('Clicked on External Job Apply', {
      buttonClicked: 'CANCEL',
      jobPostingId: jid,
    });
  }
  onPopUpOk(externalJobUrl, jid) {
    vxm.users.Rudderstack.trackEvent('Clicked on External Job Apply', {
      buttonClicked: 'OK',
      jobPostingId: jid,
    });
    return externalJobUrl == 'Login'
      ? this.openExtUrlWindowWithoutLogin
      : this.openExtUrlWindow;
  }
  openExtUrlWindow() {
    this.applyJob(this.externalJobId);
    window.open(this.externalUrl, '_blank');
  }

  openExtUrlWindowWithoutLogin() {
    this.$router.push({ name: 'Login' });
  }

  processJobApplicationResponse(apply, jid) {
    if (apply.questionareInfo) {
      localStorage.hasBranchedQuestions =
        apply.questionareInfo.hasBranchedQuestions;
      localStorage.questionTemplate = apply.questionareInfo.questionTemplateId;
    }

    if (apply.nextPage === 'otpauthentication') {
      if (vxm.utility.useLoginSignupV2) {
        this.$cookies.set('SubmitJobApplicationId', jid, 600);
      }
      this.$router.push({ name: 'Verification' });
      this.setNavigation('JobDetails:' + jid);
    }
    // error code 1001 resume
    if (
      apply.errorCode === '1001' ||
      apply.nextPage === 'questionnaire' ||
      apply.nextPage === 'supportinginfo'
    ) {
      localStorage.nextpage =
        apply.errorCode === '1001' ? 'resume' : apply.nextPage;
      localStorage.jobviewpage = '';
      if (!this.externalUrl) {
        this.goTodetail2(jid);
      }
      return;
    }

    if (apply.errorCode === '1002' || apply.errorCode === '1003') {
      this.showMessage(apply, jid);
      return;
    }

    if (apply.nextPage === 'success') {
      this.showMessage(apply, jid);
      return;
    }
    this.showMessage(apply, jid);
  }

  destroyed() {
    localStorage.nextpage = '';
  }
 
  showMessage(value, jid) {
    if (value) {
      if (!value.success) {
        if (value.errorCode === '1002' || value.errorCode === '1003') {
          let errorMessageText = value.errorMessage;
          if(value.errorCode === '1003'){
            errorMessageText = this.$t('errorcode.1124').toString();
          }
          this.$wlToastr('error', errorMessageText, this.$t('MyJobListing_JobApplication'));
        }
      } else {
        if (value.nextPage === 'success') {
          vxm.users.Rudderstack.trackEvent("Job Apply Submitted", { jobPostingId: jid });
          const successMessage = this.$t('jobs.successfully.applied');
          this.$wlToastr('success', successMessage, this.$t('MyJobListing_JobApplication'));
          vxm.jobs.setAppliedJob(jid);
          this.$router.push({ name: 'JobApplicationSuccess', params: { jid } });
        }
      }
    }
  }

  goToReferral(job) {
    let jid = job.jobPostingId;
    let jobName = job.jobPostingName;
    vxm.referrals.setJobID(parseInt(jid, 10));
    vxm.referrals.setRefferedJob(jobName);
    this.$cookies.remove('referralSuccess');
    this.$cookies.remove('frictionLess');
    if (vxm.users.isLoggedIn === false) {
      this.$router.push({ name: 'JobShare', params: { JobID: jid } });
    } else {
      const referral = new Referral();
      referral.jobPostingId = parseInt(jid, 10);
      referral.userFullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
      referral.email = vxm.users.myUserProfile.email;
      referral.referralCode = '';
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      referral.referredJobLocation = job.facility.name;
      console.log(referral);
      vxm.referrals.setReferral(referral);
      vxm.referrals.jobShareReferral(referral);
    }
    vxm.users.Rudderstack.trackEvent("Job Refer Selected", {
      JobPostingId: parseInt(jid, 10)
    })
  }

  getJobReferralProgramExists(job) {
    if (job.companyReferralIncentive !== null) {
      return job.companyReferralIncentive.companyReferralIncentiveName !== 'NA'
        ? true
        : false;
    }
    return false;
  }

  toggleReferralIndex(jobPostingId) {
    const i = this.expandedJobs.findIndex((elm) => {
      return elm === jobPostingId;
    });
    if (i === -1) {
      this.expandedJobs.push(jobPostingId);
    } else {
      this.expandedJobs.splice(i, 1);
    }
  }

  get isExpanded() {
    return (jobPostingId) => {
      const isPresent = this.expandedJobs.find((elm) => {
        return elm === jobPostingId;
      });
      return !!isPresent;
    };
  }

  getJobTagStyle(jobTagObj) {
    let styleObj = {};
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.fontColor
    ) {
      styleObj['color'] = jobTagObj.meta.style.fontColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColor
    ) {
      styleObj['background'] = jobTagObj.meta.style.backgroundColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColorOpacity
    ) {
      styleObj['opacity'] = jobTagObj.meta.style.backgroundColorOpacity;
    }
    return styleObj;
  }

  get myJobs(): Job[] {
    let jobs = vxm.jobs.Jobs;
    if (jobs) {
      jobs.forEach((job) =>
        job.savedDTTM ? (job.bookmarkStatus = 'A') : (job.bookmarkStatus = 'D'),
      );
      return jobs;
    } else {
      return [];
    }
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  renderDate(xDate: number): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return this.$moment(xDate).format(
        vxm.jobs.getCompanyDateFormat.toUpperCase(),
      );
    }
    return this.$moment(xDate).format('DD-MMM-YYYY');
  }

  truncate(str: string, len: number, suffix: string) {
    if (str.length > len) {
      return str.substring(0, len) + suffix;
    } else {
      return str;
    }
  }

  beforeMount() {
    if (localStorage.getItem('localjobs')) {
      this.localjobs = JSON.parse(localStorage.getItem('localjobs') || '[]');
    }
  }

  renderDOW(dow: number): string {
    let day = '';
    switch (dow) {
      case 0:
        day = 'Sun';
        break;
      case 1:
        day = 'Mon';
        break;
      case 2:
        day = 'Tue';
        break;
      case 3:
        day = 'Wed';
        break;
      case 4:
        day = 'Thu';
        break;
      case 5:
        day = 'Fri';
        break;
      case 6:
        day = 'Sat';
    }
    return day;
  }
  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  get bookmarkClass() {
    return (job) => {
      if (
        vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS') &&
        !this.isLoggedIn
      ) {
        if (
          this.localjobs.find(
            (savedJob) => savedJob.jobPostingId === job.jobPostingId,
          )
        ) {
          return 'fa fa-bookmark secondary-color bookmark-icon';
        } else {
          return 'fa fa-bookmark-o remove-color bookmark-icon';
        }
      }
      if (
        job.bookmarkStatus &&
        job.bookmarkStatus === 'A' &&
        job.hasAppliedJob != true
      ) {
        return 'fa fa-bookmark secondary-color bookmark-icon';
      } else {
        return 'fa fa-bookmark-o remove-color bookmark-icon';
      }
    };
  }

  getFirstCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }

  saveJobAlert() {
    const vm = this;
    vm.$wlToastr(
      'success',
      vm.$t('jobalert-saved-success-message'),
      vm.$t('JobAlert_JobAlert'),
    );
  }
  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }
  async fetchConversation(job: Job) {
    console.log('job----------------------------------->>>>', job);

    let accessTkn = vxm.users.getUserProfile();
    console.log(accessTkn, '<<<----------------accessTkn');
    try {
      let conversationResponse = await vxm.jobs.fetchExistingConversation({
        adminId: job.createdByUserId,
        userId: vxm.users.myUserProfile.userId,
        contextType: '01',
        contextId: job.jobPostingId,
        conversationType: '01',
        isAdmin: true,
      });
      console.log('Response is : ', conversationResponse);
      if (conversationResponse.conversationGUID !== null) {
        vxm.jobs.setActiveConversationGUID(
          conversationResponse.conversationGUID,
        );
        console.log('value of guid is : ', vxm.jobs.ActiveConversationGUID);
      } else {
        try {
          let sendMessage = await vxm.jobs.sendMessage({
            isAdmin: false,
            originId: vxm.users.myUserProfile.userId,
            conversation: {
              conversationGUID: null,
              initiatedBy: vxm.users.myUserProfile.userId,
              claimedBy: vxm.users.myUserProfile.userId,
              participants: [job.createdByUserId],
              context: '01',
              contextId: job.jobPostingId,
              companyCode: vxm.users.getCompanyCode,
            },
            conversationMessage: {
              origin: vxm.users.myUserProfile.userId,
              messageType: '01',
              messageText: '',
              destination: job.createdByUserId,
            },
          });
          //set in store
          vxm.jobs.setActiveConversationGUID(sendMessage.conversationGUID);
        } catch (error) {
          var uri = window.origin + '/atsuser/chat';
          console.log('uri', uri);
          (window as any).location = uri;
        }
      }
      this.$router.push({ name: 'Chat' });
    } catch (error) {
      console.log(error, '--------------------------error');
    }
  }
}
